/**
 * The fullscreen "manage" dialogs' surface — the automations workspace and its
 * runs/JSON-editor companions — as one className for `DialogPopup`. Every
 * manage dialog reads it so they feel like one surface. The other config
 * dialogs (keyboard shortcuts, custom fields, the App Center, admin, the
 * add-widget gallery) do NOT: they take the library's `size="window"` tier, a
 * bounded floating window one step below this takeover.
 *
 * `DialogPopup` is `max-w-lg` and renders its own Viewport, whose
 * `grid-rows-[1fr_auto_3fr]` is unreachable from a call site, so a
 * near-fullscreen surface states its own height and width and overrides the
 * stock cap. It insets 4rem a side under a 1560px cap.
 *
 * Desktop only: on a phone the responsive Dialog presents a sheet, which
 * ignores the popup's className.
 */
export const MANAGE_DIALOG_SURFACE =
  "h-[calc(100dvh-3rem)] w-full max-w-none sm:h-[calc(100dvh-4rem)] sm:w-[calc(100vw-4rem)] sm:max-w-[1560px]";
